// src/app/snipper/spinner-component.ts

import { Component, OnInit, ChangeDetectorRef, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner-component.html',
  styleUrls: ['./spinner-component.scss'], 
  standalone: true,
  imports: [
    CommonModule 
  ]
})
export class SpinnerComponent implements OnInit {
  datas: any;
  clientId = localStorage.getItem('client_id');

  constructor(
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit() {
    this.init();
  }

  init() {
    this.spinnerService.dataemitterr.subscribe((data) => {
      this.datas = data;
      this.cdRef.detectChanges(); 
    });
  }
}